import {DefaultRootState, useSelector} from 'react-redux';
import {FacetValuesSortOrder, HibuEqualsFilter, HibuFacetFilter, HibuFacetGroup, HibuFilter} from '../facet.types';
import {facetUtils} from '../facet.utils';

export function useFacets(): HibuFacetGroup[] {
    return useSelector((state: DefaultRootState) => state.filter.facets);
}

export function useAreFiltersPersistent(): boolean {
    return useSelector((state: DefaultRootState) => state.filter.filterPersisted);
}

export function useIsFilterGroupExpanded(group: string): boolean {
    return useSelector((state: DefaultRootState) =>
        state.filter.expandedFilterGroups.includes(group));
}

export function useSelectedFilters(): HibuFacetFilter {
    return useSelector((state: DefaultRootState) => state.filter.selectedFilters);
}

export function useSelectedFiltersForGroup(group: string): HibuFilter[] {
    return useSelector((state: DefaultRootState) =>
        state.filter.selectedFilters[group]);
}

export function useIsFilterSelected(filter: HibuEqualsFilter, selectedFilters: HibuFilter[]): boolean {
    return selectedFilters?.some(f => facetUtils.isSameEqualsFilter(f as HibuEqualsFilter, filter)) ?? false;
}

export function useIsFilterInverted(filter: HibuEqualsFilter, selectedFilters: HibuFilter[]): boolean {
    return selectedFilters?.some(f => facetUtils.isSameEqualsFilter(f as HibuEqualsFilter, filter) && facetUtils.isInvertedFilter(f as HibuEqualsFilter)) ?? false;
}

export function useIsEqualsFilterSelectedFunction(): (filters: HibuEqualsFilter, selectedFilters: HibuFilter[]) => boolean {
    return (filter: HibuEqualsFilter, selectedFilters: HibuFilter[]) => selectedFilters?.some(f => facetUtils.isSameEqualsFilter(f as HibuEqualsFilter, filter)) ?? false;
}

export function useSort(): FacetValuesSortOrder {
    return useSelector((state: DefaultRootState) =>
        state.filter.sort);
}

export function useIsShowFilters(): boolean {
    return useSelector((state: DefaultRootState) => state.filter.showFilters);
}

export function useIsFiltersPending(): boolean {
    return useSelector((state: DefaultRootState) => state.filter.facets.length === 0 && state.filter.filtersPending);
}


